<template>
    <a :href="url" :class="['btn', `btn-label-${color}`, 'btn-sm', 'btn-bold']">
        {{ i18n("views.PortalController.GeneralShow") }}
    </a>
</template>
<script setup lang="ts">
    import { i18n } from "@/portal/Trans";

    defineProps<{
        color: "success" | "primary" | "warning" | "danger";
        url: string;
    }>();
</script>
